var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline_line"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"timeline_item_small",style:(_vm.stylingItem(item))},[_c('vx-tooltip',{attrs:{"text":item ? item.start + '-' + item.end : ''}},[_vm._v("\n      "+_vm._s(item.start ? item.start.split(":", 2).join(":") : "")+"\n    ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }